<template>
  <v-dialog
    v-model="value"
    fullscreen
    transition="fade-transition"
  >
    <v-card
      color="grey darken-4"
      dark
    >
      <v-app-bar
        color="transparent"
        fixed
        flat
        class="px-3"
      >
        <v-badge
          :key="counter"
          color="primary"
          :content="counter"
          :value="counter"
        />
        <v-spacer />

        <v-btn
          icon
          small
          @click="toggleFullscreen"
        >
          <v-icon>mdi-arrow-expand-all</v-icon>
        </v-btn>

        <v-menu
          bottom
          left
          offset-y
        >
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              icon
              small
              class="mx-1 mx-md-3"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-share</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item link>
              <v-list-item-title>
                <ShareNetwork
                  network="facebook"
                  :url="`https://darialush.ru/${pictures[picture].srcOrigin}`"
                  :title="`Фото от Daria Lush. Раздел -  ${pictures[picture].category}`"
                  description="Фото с сайта https://darialush.ru/portfolio"
                  quote="Фото Daria Lush"
                  hashtags="darialush,photographer"
                >
                  Поделиться Facebook
                </ShareNetwork>
              </v-list-item-title>
            </v-list-item>

            <v-list-item link>
              <v-list-item-title>
                <ShareNetwork
                  network="vk"
                  :url="`https://darialush.ru/${pictures[picture].srcOrigin}`"
                  :title="`Фото от Daria Lush. Раздел -  ${pictures[picture].category}`"
                  description="Фото с сайта https://darialush.ru/portfolio"
                  :media="`https://darialush.ru/${pictures[picture].srcOrigin}`"
                >
                  Поделиться ВКонтакте
                </ShareNetwork>
              </v-list-item-title>
            </v-list-item>

            <v-list-item link>
              <v-list-item-title>
                <ShareNetwork
                  network="email"
                  :url="`https://darialush.ru/${pictures[picture].srcOrigin}`"
                  :title="`Фото от Daria Lush. Раздел -  ${pictures[picture].category}`"
                  description="Фото с сайта https://darialush.ru/portfolio"
                >
                  Поделиться на Email
                </ShareNetwork>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title>
                <ShareNetwork
                  network="whatsapp"
                  :url="`https://darialush.ru/${pictures[picture].srcOrigin}`"
                  :title="`Фото от Daria Lush. Раздел -  ${pictures[picture].category}`"
                  description="Фото с сайта https://darialush.ru/portfolio"
                >
                  Поделиться WhatsApp
                </ShareNetwork>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title>
                <ShareNetwork
                  network="viber"
                  :url="`https://darialush.ru/${pictures[picture].srcOrigin}`"
                  :title="`Фото от Daria Lush. Раздел -  ${pictures[picture].category}`"
                  description="Фото с сайта https://darialush.ru/portfolio"
                >
                  Поделиться Viber
                </ShareNetwork>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title>
                <ShareNetwork
                  network="telegram"
                  :url="`https://darialush.ru/${pictures[picture].srcOrigin}`"
                  :title="`Фото от Daria Lush. Раздел -  ${pictures[picture].category}`"
                  description="Фото с сайта https://darialush.ru/portfolio"
                >
                  Поделиться Telegram
                </ShareNetwork>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn
          icon
          small
          @click="galleryClosed"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <v-row
        style="height: 100vh"
        align="center"
        justify="center"
        align-content="center"
        class="ma-0"
      >
        <v-col
          class="pa-0"
          cols="12"
        >
          <v-img
            :src="pictures[picture].srcOrigin"
            class="pa-0"
            contain
            max-height="100vh"
            width="100%"
          >
            <v-row
              v-touch="{
                left: () => swipe(1),
                right: () => swipe(-1),
              }"
              style="height: 100%;"
              align="end"
              justify="center"
            >
              <v-col class="d-none d-md-block">
                <v-row
                  align="end"
                  justify="center"
                >
                  <v-btn
                    depressed
                    class="transparent"
                    fab
                    :disabled="leftStop"
                    @click="swipe(-1)"
                  >
                    <v-icon
                      large
                    >
                      mdi-arrow-left-bold-circle
                    </v-icon>
                  </v-btn>
                  <v-btn
                    depressed
                    class="transparent"
                    fab
                    :disabled="rightStop"
                    @click="swipe(1)"
                  >
                    <v-icon
                      large
                    >
                      mdi-arrow-right-bold-circle
                    </v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-img>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
// Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'
  import { get, sync } from 'vuex-pathify'

  export default {
    name: 'GalleryCarouselHome',

    mixins: [Proxyable],

    data () {
      return {
        isFullscreen: false,
        rightStop: false,
        leftStop: false,
        counter: '',
      }
    },
    computed: {
      picture: sync('photographs/picture'),
      pictures: get('photographs/pagPictures'),
    },

    methods: {
      toggleFullscreen () {
        if (document.fullscreenElement) {
          document.exitFullscreen()
          this.isFullscreen = false
        } else {
          document.documentElement.requestFullscreen()
          this.isFullscreen = true
        }
      },
      swipe (direction) {
        this.rightStop = false
        this.leftStop = false
        const setIndex = this.picture + direction
        if (setIndex <= 0) {
          this.counter = `1 из ${this.pictures.length}`
          this.picture = 0
          this.leftStop = true
        } else if (setIndex >= this.pictures.length - 1) {
          this.counter = `${this.pictures.length} из ${this.pictures.length}`
          this.picture = this.pictures.length - 1
          this.rightStop = true
        } else {
          this.counter = `${setIndex + 1} из ${this.pictures.length}`
          this.picture = setIndex
        }
      },
      galleryClosed () {
        this.rightStop = false
        this.leftStop = false
        this.counter = ''
        this.$emit('change', false)
      },
    },
  }
</script>
